import React, { useEffect, useState } from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import {
  LoadingOutlined,
  PlusOutlined,
  FileImageOutlined,
  PictureOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  Layout,
  Space,
  Typography,
  theme,
  Input,
  Radio,
  Button,
  Flex,
  Col,
  Row,
  Modal,
  Form,
  Skeleton,
  message,
  Empty,
  Spin,
  Select
} from "antd";
import AddCompanyForm from "../../components/company/AddCompanyForm";
import CompanyCard from "../../components/company/CompanyCard";
import { useUserContext } from "../../contexts/UserContext";
import companyService from "../../services/companyService";
import { useParams } from "react-router-dom";
import consultantService from "../../services/consultantService";
import Dropdown from "../../components/dropdown/Dropdown";
import Search from "../../components/search/Search";

const { Content } = Layout;

const Companies = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const { id: userId, role } = useUserContext();
  const { consultantId } = useParams();

  const [form] = Form.useForm();

  const [messageApi, contextHolder] = message.useMessage();
  const key = "updatable";

  const [openModal, setOpenModal] = useState(false);
  const [cardContentLoading, setCardContentLoading] = useState(true);

  const [consultantData, setConsultantData] = useState({});

  const [showEvaluatedCompanies, setShowEvaluatedCompanies] = useState(false)
  const [evaluatedCompaniesData, setEvaluatedCompaniesData] = useState([])
  const [unevaluatedCompaniesData, setUnevaluatedCompaniesData] = useState([])
  const [companiesData, setCompaniesData] = useState([])
  const [displayCompanies, setDisplayCompanies] = useState([])

  const getValueFromLocalStorage = (type) => {
    const key = type === 'index' ? 'ReadinessIndexType' : 'SelectedFilter';
    const localStorageValue = localStorage.getItem(key);
    if (localStorageValue) {
      if (type === 'index' && localStorageValue === 'web3.0') {
        localStorage.setItem(key, 'genai');
        return 'genai';
      }
      return localStorageValue;
    }
    const value = type === 'index' ? 'genai' : 'all';
    localStorage.setItem(key, value);
    return value;
  }


  const [readinessIndexType, setReadinessIndexType] = useState(getValueFromLocalStorage('index'))
  const [companiesFilter, setCompaniesFilter] = useState(getValueFromLocalStorage('filter'))

  const handleClose = () => {
    form.resetFields();
    setOpenModal(false);
  };

  const fetchCompanies = (consultantId) => {
    setCardContentLoading(true);
    setShowEvaluatedCompanies(false);
    consultantService
      .getConsultantById(consultantId)
      .then((response) => {
        const { companies, ...rest } = response?.data;

        setConsultantData(rest);

        setConsultantData(rest)
        setCompaniesData(companies)
        console.log('companiesFilter: ',companiesFilter,'readinessIndexType',readinessIndexType)
        console.log('companies:' ,companies)
        console.log('filter companies output :',filterCompanies(companiesFilter, readinessIndexType, companies))
        filterCompanies(companiesFilter, readinessIndexType, companies)
        // setReadinessIndexType(localStorage.getItem('ReadinessTypeIndex'))
        // setCompaniesFilter('all')
        
        const [notEvaluated, evaluated] = companies.reduce(
          ([notEvaluated, evaluated], item) => {
            return item.isEvaluated
              ? [notEvaluated, [...evaluated, item]] // Add to evaluated array
              : [[...notEvaluated, item], evaluated]; // Add to notEvaluated array
          },
          [[], []] // Initialize empty arrays
        );

        setCardContentLoading(false);
        setEvaluatedCompaniesData(evaluated);
        setUnevaluatedCompaniesData(notEvaluated);
      })
      .catch((error) => console.log(error));
  };

  const handleViewChange = (e) => {
    const value = e.target.value;
    if (value === "evaluated") {
      setShowEvaluatedCompanies(true);
    } else if (value === "unevaluated") {
      setShowEvaluatedCompanies(false);
    }
  };

  const filterCompanies = (filterValue, readinessIndexType, dataSource) => {
    if(filterValue === 'all') {
      setDisplayCompanies(dataSource)
    }
    else {
      const data = dataSource.filter(obj => obj.evaluationDetails[readinessIndexType].status == filterValue)
      setDisplayCompanies(data)
    }
  }

  const handleCompaniesFilterChange = (value) => {
    setCompaniesFilter(value)
    localStorage.setItem('SelectedFilter', value)
    filterCompanies(value, readinessIndexType, companiesData)
  }

  const handleIndexChange = (value) => {
    setReadinessIndexType(value)
    localStorage.setItem('ReadinessIndexType', value)
    filterCompanies(companiesFilter, value, companiesData)
  }


  useEffect(() => {
  
    fetchCompanies(role === "admin" ? consultantId : userId);
  }, []);

  const dropDownStyle = {
    padding: "19px 20px 19px 20px",
    width: "279px",
    height: "55px",
    backgroundColor: "red",
    color: "#C0C0CF",
  };


  console.log('readinessIndexType: ',readinessIndexType)
  return (
    <>
      {contextHolder}
      <Layout style={{ minHeight: "100vh", minWidth: '1800px', display:"flex", flexDirection:"column", gap:"35px"}}>
        <Header bgColor={colorBgContainer} />
        <Content
          style={{
            padding: "0 40px 0px 40px",
            // border:"2px solid green"
          }}
        >
          <div
            style={{
              background: colorBgContainer,
              minHeight: 280,
              padding: 35,
              // borderRadius: borderRadiusLG,
              borderRadius: "15px",
              // marginTop: 16,
              // border: '2px solid red'
              marginBottom: 35
            }}
          >
            <Space  style={{justifyContent: 'space-between', alignItems: 'center', width: '100%', marginBottom:'24px'}}>
              <Typography.Title style={{fontSize:'25px', fontWeight:'700', color:'#07224D'}}>Companies</Typography.Title>
              {
                role === 'admin' ? 
                <Typography.Title level={5}>
                  {!cardContentLoading ? consultantData?.userName && `Consultant: ${consultantData.userName}` :
                  <div style={{width: '150px', textAlign: 'center'}}><Spin indicator={<LoadingOutlined spin />} /></div>
                }
                </Typography.Title> :
                <Button
                  style={{
                    backgroundColor: "#3BA4FE",
                    padding: "20px 32px 20px 32px",
                    color: "#FFFFFF",
                    fontSize: "18px",
                    height: "62px",
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: 10
                  }}
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() => setOpenModal(true)}
                >
                  Add Company
                </Button>
              }
            </Space>
            <Flex style={{ width: '100%' }} justify={'space-between'} align={'center'} gap={20}>
              <Search/>
                {/* <div style={{padding:'20px' ,backgroundColor:'purple'}}> */}
                <Select
                  // style={{ width: 120 }}
                  style={{width:279 , height:55}}
                  value={readinessIndexType}
                  onChange={handleIndexChange}
                  options={[
                    {
                      value: 'genai',
                      label: 'Gen AI',
                    },
                  ]}
                  className="custom-dropdown"
                  classNamePrefix="custom-dropdown"
                />

                {/* </div> */}
                
                <Select
                  style={{ width:279 , height:55 }}
                  value={companiesFilter}
                  onChange={handleCompaniesFilterChange}
                  options={[
                    {
                      value: 'all',
                      label: 'All',
                    },
                    {
                      value: '0',
                      label: 'Not Evaluated',
                    },
                    {
                      value: '1',
                      label: 'Evaluation in Progress',
                    },
                    {
                      value: '2',
                      label: 'Evaluated',
                    }
                  ]}
                />
            </Flex>
            {cardContentLoading ? <Row gutter={[36, 36]} style={{ marginTop: '48px', marginBottom: '48px' }}>
              <Col span={6}>
                <Skeleton active avatar={true} paragraph={{rows: 3}} style={{ padding: 18 }}></Skeleton>
              </Col>
              <Col span={6}>
                <Skeleton active avatar={true} paragraph={{rows: 3}} style={{ padding: 18 }}></Skeleton>
              </Col>
              <Col span={6}>
                <Skeleton active avatar={true} paragraph={{rows: 3}} style={{ padding: 18 }}></Skeleton>
              </Col>
              <Col span={6}>
                <Skeleton active avatar={true} paragraph={{rows: 3}} style={{ padding: 18 }}></Skeleton>
              </Col>
            </Row> :
            <Row gutter={[36, 36]} style={{ marginTop: '48px', marginBottom: '48px' }}>
              {
                displayCompanies.length === 0 ?
                <Empty style={{ width: '100%' }} image={Empty.PRESENTED_IMAGE_SIMPLE} /> :
                displayCompanies.map((company) => <Col span={6} key={company.id}>
                  <CompanyCard companyData={company} readinessIndexType={readinessIndexType} />
                </Col>)
              }
            </Row>}
            <Modal
              title="Add New Company"
              open={openModal}
              onCancel={handleClose}
              mask={true}
              maskClosable={false}
              footer={null}
            >
              <AddCompanyForm
                form={form}
                handleClose={handleClose}
                messageApi={messageApi}
                messageKey={key}
                fetchCompanies={fetchCompanies}
              />
            </Modal>
          </div>
        </Content>
        <Footer />
      </Layout>
    </>
  );
};

export default Companies;
